/**
 * How the player moves between pages during a tour.
 *
 * Web satisfies this with the Angular router directly. NativeScript cannot: its
 * shells run a native `TabView` with one named `page-router-outlet` per tab, the
 * visible tab set is user-configurable, and iOS caps the bar at five items — so
 * reaching a step's page can mean selecting a tab before navigating, and a route
 * string alone is not sufficient addressing.
 */
export interface IWalkthroughNavigator {
  /** The route currently displayed, for the "am I already there?" guard that
   * keeps a same-page step from triggering a page reload. */
  currentRoute(): string;

  /** Navigate to `route`, resolving once the destination is displayed. */
  navigate(route: string): Promise<void>;
}
